import React from "react";
import { Card, Col, Container, Row } from "reactstrap";
import BreadCrumb from "../../../Components/Common/BreadCrumb";
import OrganizationRelationshipListing from "./OrganizationRelationshipListing";

const OrganizationRelationship = () => {
  const breadcrumbItems = [
    { title: "Org", link: "" },
    { title: "Organization Relationship", link: "/org/relationship" },
  ];

  // document.title="Org"
  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <BreadCrumb items={breadcrumbItems} />
          <Card>
            <OrganizationRelationshipListing />
          </Card>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default OrganizationRelationship;